import { QlikApi } from "../../dataTypes";

const getAppsFromQlikApi = async (qlikApi: QlikApi) => {
  return await qlikApi.getDocList();
};

export default getAppsFromQlikApi;
